import { combineReducers } from 'redux';
import authReducer from './authReducer';
import ociInstancesReducer from './ociInstancesReducer';
import cigConfigReducer from './cigConfigReducer';
import inviteReducer from '../pages/invite/reducer';

export default combineReducers({
    auth: authReducer,
    oci: ociInstancesReducer,
    invite: inviteReducer,
    config: cigConfigReducer,
});
